import { Action, createReducer, on } from '@ngrx/store';
import { initialState } from '../states/applet-audit-trail.states';
import { AuditTrailStates } from '../states';
import { AuditTrailActions } from '../actions';

export const auditTrailReducer = createReducer(
    initialState,
  on(AuditTrailActions.loadAuditTrailSuccess, (state, action) =>
    ({ ...state, totalRecords: action.totalRecords })),

  on(AuditTrailActions.updateAgGridDone, (state, action) => ({
    ...state,
    selectAgGrid: action.done,
  })),
  on(AuditTrailActions.selectedAuditTrail, (state, action) => ({
    ...state,
    selectAuditTrail: action.auditTrail,
  })),
)

export function reducer(state: AuditTrailStates | undefined, action: Action) {
    return auditTrailReducer(state.auditTrail, action);
}